<template>
  <div class="flex w-full flex-col-reverse gap-2 md:flex-row">
    <div
      class="page-back flex grow md:justify-start max-md:[&>button]:w-full md:[&>button]:w-[200px]"
    >
      <slot name="back" />
    </div>

    <div
      class="page-next flex grow md:justify-end max-md:[&>button]:w-full md:[&>button]:w-[200px]"
    >
      <slot name="next" />
    </div>
  </div>
</template>

<script setup lang="ts">
  interface Slots {
    back(): never
    next(): never
  }

  defineSlots<Slots>()
</script>
